export type QueryBuilderEntityTokenType = {
  type: 'entity';
  entityKey: string;
};

export type QueryBuilderEntityValueTokenType = {
  type: 'entityValue';
  entityKey: string;
  value: string;
};

export type QueryBuilderOperatorType = 'AND' | 'OR';

export type QueryBuilderOperatorTokenType = {
  type: 'operator';
  operator: QueryBuilderOperatorType;
};

export type QueryBuilderBracketType = 'OPEN' | 'CLOSE';

export type QueryBuilderBracketTokenType = {
  type: 'bracket';
  bracket: QueryBuilderBracketType;
};

export type QueryBuilderTokenType =
  | QueryBuilderEntityTokenType
  | QueryBuilderEntityValueTokenType
  | QueryBuilderOperatorTokenType
  | QueryBuilderBracketTokenType;

export type QueryBuilderInputContextType =
  | 'expectOperand'
  | 'expectValue'
  | 'expectOperatorOrClose';

export type ConditionNodeType = {
  type: 'condition';
  entityKey: string;
  value: string;
};

export type GroupNodeType = {
  type: 'group';
  operator: QueryBuilderOperatorType;
  children: QueryBuilderAstNodeType[];
};

export type QueryBuilderAstNodeType = ConditionNodeType | GroupNodeType;

export type QueryBuilderEntityValueOptionType = {
  id?: string;
  label: string;
};

export type QueryBuilderEntityConfigType = {
  key: string;
  label: string;
  color?: string;
  loadValues: (search: string) => Promise<QueryBuilderEntityValueOptionType[]>;
};

export type QueryBuilderTypingCommitActionType =
  | { type: 'entity'; entityKey: string }
  | { type: 'entityValue'; entityKey: string; value: string }
  | { type: 'value'; value: string }
  | { type: 'operator'; operator: QueryBuilderOperatorType }
  | { type: 'openBracket' }
  | { type: 'closeBracket' };

export type SavedQueryType = {
  id: string;
  name: string | null;
  ast: QueryBuilderAstNodeType;
};

export type ShareQueryMutateOptionsType = {
  onSuccess: (uuid: string) => void;
  onError: (error: unknown) => void;
};

export type ShareQueryMutateType = (
  ast: QueryBuilderAstNodeType,
  options: ShareQueryMutateOptionsType
) => void;

export type QueryBuilderShareQueryConfigType = {
  mutate: ShareQueryMutateType;
  buildShareUrl: (uuid: string) => string;
  onSuccess?: (uuid: string) => void;
  onError?: (error: unknown) => void;
};

export type QueryBuilderInputPropsType = {
  entities: QueryBuilderEntityConfigType[];
  savedQueries: SavedQueryType[];
  onChange: (ast: QueryBuilderAstNodeType | null) => void;
  onSaveQuery: (name: string, ast: QueryBuilderAstNodeType) => void;
  onDeleteSavedQuery: (id: string) => void;
  shareQuery: QueryBuilderShareQueryConfigType;
  initialAst?: QueryBuilderAstNodeType;
};

export const QUERY_BUILDER_OPERATORS: QueryBuilderOperatorType[] = [
  'AND',
  'OR',
];

export const QUERY_BUILDER_OPEN_BRACKET = '(';
export const QUERY_BUILDER_CLOSE_BRACKET = ')';
export const QUERY_BUILDER_KEYWORD_ENTITY_KEY = 'keyword';
